/**
 * All of the possible views that are shown in the "form" section of the page
 */
export enum View {
    HOME = 1,
    ORDER = 2,
    ACCOUNT = 3
}
